import styles from "./main.module.css";
import { ReactComponent as Home } from "../../assets/svgs/home.svg";
import { ReactComponent as Nomination } from "../../assets/svgs/nomination.svg";
import { ReactComponent as Voting } from "../../assets/svgs/voting.svg";
import { ReactComponent as Results } from "../../assets/svgs/result.svg";
import { ReactComponent as InfoCenter } from "../../assets/svgs/info-center.svg";
import SideBarItem from "./sidebarItems/main";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userAtom, profileDetails } from "../../utils/store";
import { getMemberPersonalDetailCall } from "../helpers";

interface SideBarProps {
  icon?: React.ReactNode;
  name?: string;
  display?: string;
  className?: any;
}

const sideBarItems = [
  {
    icon: <Home />,
    name: "Home",
    link: "/home"
  },
  {
    icon: <Nomination />,
    name: "Nomination",
    link: "/nomination"
  },
  {
    icon: <Voting />,
    name: "Voting",
    link: "/voting"
  },
  {
    icon: <Results />,
    name: "Election Results",
    link: "/election-results"
  },
  {
    icon: <InfoCenter />,
    name: "Information Center",
    link: "/information-center"
  },
];



const SideBar: React.FC<SideBarProps> = ({
  display,
  className,
}) => {
   const resetUser = useResetAtom(userAtom);
    const resetUserDetails = useResetAtom(profileDetails);
    const navigate = useNavigate();
    const user = useAtomValue(userAtom);
    const setUserProfileDetails = useSetAtom(profileDetails);
    const membershipId = user?.MemberId;
  const {
    data: memberData,
    isLoading,
    isError,
    error,
    isSuccess
  } = useQuery({
    queryKey: ["get-member-data"],
    queryFn: () => getMemberPersonalDetailCall(membershipId),
    refetchOnWindowFocus: false,
    enabled: !!membershipId,
  });
  const userDetails = memberData?.Data;

  useEffect(() => {
    if (userDetails !== null && isSuccess) {
      setUserProfileDetails({
        FirstName: userDetails?.FirstName ?? "",
        MembershipNo: userDetails?.MembershipNo ?? "",
        UploadPictureUrl: userDetails?.UploadPictureUrl ?? "",
        MiddleName: userDetails?.MiddleName ?? "",
        LastName: userDetails?.LastName ?? "",
        Email: userDetails?.Email ?? "",
        PhoneNumber: userDetails?.PhoneNumber ?? "",
        Name: userDetails?.Name ?? "",
        Gender: userDetails?.Gender ?? "",
        MembershipType: userDetails?.MembershipType ?? "",
        DateBirth: userDetails?.DateBirth ?? "",
        WhatsAppNumber: userDetails?.WhatsappNumber ?? "",
        ResidentialAddress: userDetails?.ResidentialAddress ?? "",
        StateId: userDetails?.StateId ?? "",
        StateOriginId: userDetails?.StateOriginId ?? "",
        LicenseExpire: userDetails?.LicenseExpire ?? "",
        CreatedDate: userDetails?.CreatedDate ?? "",
      });
    }
  }, [userDetails, setUserProfileDetails]);
  return (
    <aside
      className={className}
      style={{
        paddingInline: "12px",
        borderInlineEnd: "1px solid #E5E6E6",
        display: display,
      }}
    >
      <div className={styles.sideBarSub}>
        <div className={styles.mainSideBarItem}>
          <div className={styles.ciipmlogo}></div>
          <h1>CIPM</h1>
        </div>

        <div>
          {sideBarItems.map((item, index) => (
            <SideBarItem key={index} name={item.name} icon={item.icon} link={item.link} isActive={window.location.href.endsWith(item?.link)}/>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
